<template>
 <h1 class="system_content_title">评价工作管理—企业列表</h1>
    <div class="system_content_panels">
      <div class="systemPanel" style="position: relative; padding-bottom: 40px">
    <el-form :inline="true" class="select_form">
      <el-form-item>
        <el-button type="primary" @click="showAddCompany">新增</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-input
          v-model="state.searchInput"
          placeholder="请输入名称"
          clearable
          @clear="getTableData"
        >
          <template #append>
            <el-button icon="Search" @click="getTableData" />
          </template>
        </el-input>
      </el-form-item> -->
    </el-form>
    <el-table
      :data="state.tableData"
      stripe
      border
      v-loading="state.loading"
      style="min-height:70vh"
      table-layout="fixed"
    >
      <el-table-column type="index" width="50" />
      <el-table-column prop="companyName" label="企业名称" />
      <el-table-column prop="regionFullName" label="行政区域" />
      <el-table-column prop="flowStepname" label="当前流程" />
      <el-table-column prop="nextFlowStepName" label="下一流程" />
      <el-table-column prop="scorelevel1" label="自评等级" />
      <el-table-column prop="score1" label="自评分数" />
      <el-table-column prop="scorelevel2" label="审核等级" />
      <el-table-column prop="score2" label="审核分数" />
      <el-table-column label="操作">
        <template #default="scope">
          <!-- <el-button
                  size="small"
                  type="warning"
                  @click="showAddCompany(scope.row)"
                  style="margin-bottom: 2px;margin-right:2px"
                  >编辑</el-button
                > -->
          <el-popconfirm
            title="确定删除吗？"
            @confirm="deleteItem(scope.row.id)"
          >
            <template #reference>
              <el-button size="small" type="danger" style="margin-bottom: 2px"
                >删除</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="state.pageInfo.pageIndex"
      :page-sizes="[20, 50, 100, 200, 500, 1000]"
      :page-size="state.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="state.pageInfo.totalRowCount"
      v-if="state.pageInfo.totalRowCount"
      class="pageinfo"
    >
    </el-pagination>
    <el-dialog
      v-model="state.addVisible"
      title="添加企业"
      width="30%"
      :before-close="handleClose"
    >
      请选择用户：
      <el-select
        v-model="state.addCompanyList"
        filterable
        remote
        multiple
        placeholder="输入名称或信用代码"
        :remote-method="searchUser"
        :loading="state.addSearchLoading"
        style="margin-bottom: 10px"
      >
        <el-option
          v-for="item in state.userList"
          :key="item.id"
          :label="item.name + ' - ' + item.orgCode"
          :value="item.id"
        />
      </el-select>

      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="addCompanies"
            :disabled="!state.addCompanyList"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
      </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    // const roleId = router.currentRoute.value.query.roleId
    const state = reactive({
      tableData: [],
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      roleList: [],
      userList: [],
      addUser: null,
      role: null,
      companySearchInput: "",
    });
    if (!route.query.taskid) {
      ElMessage({
        message: "没有该工作任务，将返回到工作任务列表",
        type: "error",
      });

      setTimeout(() => {
        router.push("/system/review/reviewtaskslist ");
      }, 3000);
    }
    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.reviewTaskApi.getCompaniesByTaskID({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,
        headId: route.query.taskid,
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getTableData();

    const getRoleList = async (e) => {
      state.addSearchLoading = true;
      const { data } = await api.userApi.queryRole({
        page: 1,
        rows: 299,
        order: "asc",
        sort: "",
        value: "",
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        state.roleList = data.resultObj.data;
      }
      state.addSearchLoading = false;
    };
    getRoleList();

    const deleteItem = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.reviewTaskApi.deleteCompanyFromTask(id);
      console.info("search user", data);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
      state.addSearchLoading = false;
    };
    const handleClose = () => {
      state.addVisible = false;
      state.addSearch = "";
      state.addUser = "";
    };
    const addCompanies = async () => {
      //  const idArr=state.addCompanyList.map(item=>{

      //       return {
      //         id:item
      //       }
      //      })
      let idArr = [];
      state.addCompanyList.forEach((itemID) => {
        state.userList.forEach((companyItem) => {
          if (companyItem.id == itemID) {
            idArr.push({
              id: companyItem.id,
              name:companyItem.name,
              regionFullName:companyItem.regionFullName,
              regionId:companyItem.regionId
            });
          }
        });
      });


      const { data } = await api.reviewTaskApi.addCompaniesToTask(
        route.query.taskid,
        idArr
      );
      console.info("addCompany", data);
      if (data.isSuccessful) {
        ElMessage({
          message: "操作成功",
          type: "success",
        });
        handleClose();
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };

    const showAddCompany = (item) => {
      state.addVisible = true;
    };
    const searchUser = async (e) => {
      state.addSearchLoading = true;
      const { data } = await api.companyApi.getGZCompanies({
        page: 1,
        rows: 399,
        order: "asc",
        sort: "",
        value: e,
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        state.userList = data.resultObj.data;
      }
      state.addSearchLoading = false;
    };
    return {
      state,
      getTableData,
      searchUser,
      handleClose,
      addCompanies,
      deleteItem,
      showAddCompany,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
